<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  data () {
    return {
      locale: zhCN,
      token: ''
    }
  }
}
</script>
<style lang="less">
#app {
  // color: white;
  background-color: white;
  margin: 0 auto;
  font-size: 0.14rem;
  position: relative;
  overflow: hidden;
  //   min-height: 740px;
}
</style>
